import { css } from '@bts-web/utils-style-engine';
import { AcceptTermToggle } from '../../../../../../common/components/AcceptTermToggle/AcceptTermToggle.use-client';
import {
  AppUserFullInfo,
  DocumentationExternalLink,
  HTMLRenderer,
} from '../../../../../../common';
import { TradeOfferDataNonNullable } from '../../../../types';

export interface AcceptOfferComplexProductsTermsTranslations {
  costTransparencyTitle: string;
}

interface AcceptOfferComplexProductsTermsProps {
  translations: AcceptOfferComplexProductsTermsTranslations;
  legalDocumentUrl: string;
  termsAgreed: boolean;
  setTermsAgreed: () => void;
  warnings: TradeOfferDataNonNullable['warnings'];
  complexAppropriatenessStatus: NonNullable<
    AppUserFullInfo['appropriatenessComplexProducts']
  >['status'];
}

const AcceptOfferComplexProductsTerms = ({
  translations,
  legalDocumentUrl,
  warnings,
  termsAgreed,
  complexAppropriatenessStatus,
  setTermsAgreed,
}: AcceptOfferComplexProductsTermsProps) => {
  const riskWarning = warnings?.find(
    (warning) => warning.messageKey === 'risk_warning',
  );

  let riskWarningParagraphs;

  if (riskWarning?.message) {
    riskWarningParagraphs = riskWarning.message.split('\n\n');
  }

  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        gap: 'medium',
        alignItems: 'start',
        alignSelf: 'flex-start',
        textAlign: 'left',
      })}
      data-testid="buy-terms-complex"
    >
      <DocumentationExternalLink
        size="small"
        visual="primaryUnderline"
        href={legalDocumentUrl}
        label={translations.costTransparencyTitle}
      />

      {complexAppropriatenessStatus === 'NOT_APPROPRIATE' &&
        riskWarningParagraphs && (
          <AcceptTermToggle
            termsAgreed={termsAgreed}
            onToggleCallback={setTermsAgreed}
            label={<HTMLRenderer>{riskWarningParagraphs[0]}</HTMLRenderer>}
            detailedDescription={riskWarningParagraphs[1]}
            data-testid="risk-warning"
          />
        )}
    </div>
  );
};

export { AcceptOfferComplexProductsTerms };
